app.controller('changePasswordCtrl',
    ['$scope', '$routeParams', '$http', '$window', '$q',
    function ($scope, $routeParams, $http, $window, $q) {

    
    $scope.User = {};
    $scope.User.GeneratedKey = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);


    $scope.modalMessage = {
        message: '',
        param: {}
    };


    $scope.infolengthpass = true;

        // confirm password harus sama
    $scope.ConfirmPassword = '';
    $scope.checkPassword = function () {
        if ($scope.ConfirmPassword != $scope.User.NewPassword) {
            $scope.formChange.txtConfirmPassword.$invalid && formChange.$submitted == true;
            $scope.infolengthpass = true;
        }
    };

        // get params, jika genkey salah maka kembali ke halaman awal / login
    if ($routeParams.generatedkey) {
        console.log('asdas');
        $http({
            method: 'GET',
            url: 'service/client.svc/changePassword?key=' + $scope.User.GeneratedKey
        }).then(function (data) {
            if (!data.data.d.result) {
                $window.location.href = "/#/"; return;
            }
            console.log(data.data.d);
            $scope.User.Email = data.data.d.email;
        }, function (error) { });
    }

    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    var allPromise = $q.all([
      $http({
          method: 'GET',
          url: 'service/client.svc/GetChangePasswordKey?key=' + window.location.href.substr(window.location.href.lastIndexOf('/') + 1),
      }).then(function (data) {
          $scope.User.Email = data.data.d.email;
          $scope.result = data.data.d;
          var SWALtranslate = $scope.SWALtranslate($scope.result.message);
          if ($scope.result.message == "LinkExpired") {

              $rootScope.AlertShowFooter('warning', SWALtranslate.title, SWALtranslate.message,
                  `<small><a id="resendOTP" >` + SWALtranslate.footer + `</a></small>`, 0);

              $("#resendOTP").on("click", function () {

                  var urlsvc = '/service/client.svc/Forget_Password'; // 1
                  var preconfirmtranslate = "sendforgetpassword"; // 2
                  var postData = { UserForget: $scope.User } // 3
                  var method = "POST"; // 4
                  //var urlsvc = '/service/client.svc/Forget_Password'; // 1
                  //var preconfirmtranslate = "resendactivationlink"; // 2 
                  //var postData = {}; // 3
                  //var method = "GET"; // 4
                  $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                      if (issuccess) // 6 
                          $window.location.href = "#/login";
                  });
              });
              return
          }
          if ($scope.result.message == "LinkUsed") {
              var SWALtranslate = $scope.SWALtranslate('LinkUsed');
              Swal.fire(SWALtranslate.title, SWALtranslate.message, 'warning');

              $window.location.href = "#/login";
          }
      }, function (error) { }),
    ]);

    $scope.submit = function () {
        console.log($scope.User);
        var urlsvc = 'service/client.svc/changePassword'; // 1
        var preconfirmtranslate = "changepasswordconf"; // 2
        var postData = { chgPass: $scope.User } // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/login";
        });
    };

}]);